import get from 'lodash-es/get'

import { getUserProfileRequest, formatUserResponse } from '../../utils/user'
import { getBookmarksForItems } from './bookmark'
import { getSession } from '../../utils/auth'
import { getGuestUserCart } from './cart'
import bootPinterest from '../../utils/bootPinterest'
import { logError } from '../../utils/errors'
import { setGAUserID } from '../../analytics/userAnalytics'
import { showAlert } from '../common'
import {
  getSessionRequestAction,
  getSessionSuccessAction,
  getSessionFailureAction
} from './session'
import {
  getUserRequestAction,
  getUserSuccessAction,
  getUserFailureAction,
  getGuestUserAction
} from './profile'
import { autoSignIn } from '../../utils/signInHelpers'

const USER_CONFIRMATION_PATH = '/user_confirmation'

const bootServices = (user = null) => {
  bootPinterest.boot(user)
}

/**
 * When SSO request failed
 */
const handleUnAuthenticatedAction = () => {
  return dispatch => {
    dispatch(getGuestUserAction())
    // get guest user cart
    return dispatch(getGuestUserCart())
  }
}

const handleDisabledUser = () => dispatch => {
  dispatch(
    showAlert(
      "Sorry, it looks like you're currently locked out of your account. Please contact <a href='https://help.market.envato.com/hc/en-us/requests/new'>Help Team</a> for more details.",
      'warning'
    )
  )
  dispatch(getSessionFailureAction())
  return dispatch(getUserFailureAction())
}

const getUSDollarsNotice = usDollarsNotice => ({
  type: 'getUSDollarsNotice',
  payload: { usDollarsNotice: usDollarsNotice }
})

const attemptAutoSignIn = () => (dispatch, getState) => {
  const currentSite = getState().common.currentSite
  const location = getState().router.location

  if (location.query.auto_signin === 'true') {
    const payload = {
      to: currentSite
    }

    return autoSignIn(payload)
  }

  return Promise.reject()
}

export const getUserProfile = jwtToken => (dispatch, getState) => {
  dispatch(getUserRequestAction())
  return getUserProfileRequest(jwtToken)
    .then(formatUserResponse)
    .then(user => {
      // until the user_confirmation page is hosted under shopfront, we can only use external urls instead of using React-router `Link`
      if (user.profile && !get(user, 'profile.accepted_initial_terms')) {
        window.location = USER_CONFIRMATION_PATH
      }

      bootServices(user)
      setGAUserID(get(user, 'profile.id'))
      return dispatch(getUserSuccessAction(user))
    })
    .then(() => {
      dispatch(getBookmarksForItems())
    })
    .catch(err => {
      const res = err.response
      if (res && res.status === 403 && res.data.reason === 'user-disabled') {
        return dispatch(handleDisabledUser())
      } else {
        return Promise.reject(logError(err))
      }
    })
    .catch(() => {
      return dispatch(getUserFailureAction())
    })
}

export const getUser = () => {
  return (dispatch, getState) => {
    dispatch(getSessionRequestAction())

    return getSession()
      .then(res => {
        dispatch(getSessionSuccessAction(res.data.token))
        dispatch(getUserProfile(res.data.token))
        dispatch(getUSDollarsNotice(res.headers['x-display-us-dollars-notice']))
      })
      .catch(getSessionError => {
        bootServices()

        if (get(getSessionError, 'response.status') === 401) {
          dispatch(
            getUSDollarsNotice(
              get(getSessionError, 'response.headers', {})[
                'x-display-us-dollars-notice'
              ]
            )
          )
        }

        return dispatch(attemptAutoSignIn())
          .then(jwtToken => {
            dispatch(getSessionSuccessAction(jwtToken))
            dispatch(getUserProfile(jwtToken))
          })
          .catch(() => {
            dispatch(getSessionFailureAction())
            return dispatch(handleUnAuthenticatedAction())
          })
      })
  }
}
